import React from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import {
  GetState,
  GetAllRankedMeasureData,
  AddRankedMeasureData,
  DeleteRankedMeasureData,
} from "../../../../api/User/ACG/RankedMeasureDataApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";

const schema = Yup.object().shape({
  fips: Yup.number()
    .integer("FIPS must be an integer")
    .typeError("Please enter a valid number")
    .required("Please enter FIPS"),
  county: Yup.string().matches(/^[a-zA-Z0-9\s-]*$/, 'No special characters are allowed.').required("Please enter County"),
  state: Yup.string().matches(/^[a-zA-Z0-9\s-]*$/, 'No special characters are allowed.').required("Please enter state"),
  state_Short: Yup.string().matches(/^[a-zA-Z0-9\s-]*$/, 'No special characters are allowed.').required("Please enter state (short)"),
  fair_Poor_Health_Rate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter Fair or Poor Health"),
  avg_Days_Physically_Unhealthy: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter Average Number of Physically Unhealthy Days"),
  avg_Days_Mentally_Unhealthy: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter Average Number of Mentally Unhealthy Days"),
  smokers_Rate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter smokers"),
  adults_Obesity_Rate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter Adults with Obesity"),
  food_Environment_Index: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter Food Environment Index"),
  physically_Inactive_Rate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter physically inactive"),
  exercise_Opportunities_Rate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter With Access to Exercise Opportunities"),
  primary_Care_Physicians_Rate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter primary care physicians rate"),
  dentist_Rate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter dentist rate"),
  mental_Health_Provider_Rate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter mental health provider rate"),
  preventable_Hospitalization_Rate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter preventable hospitalization rate"),
  annual_Mammogram_Rate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter With Annual Mammogram"),
  vaccinated_Rate: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter vaccinated"),
});

const RankedMeasureData = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [states, setStates] = useState([]);
  const [stateid, setStateid] = useState("");
  const stateRef = useRef(null);
  const buttonRef = useRef(null);
  const column = [
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "FIPS",
      field: "fips",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "County",
      field: "county",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "State",
      field: "state",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "State (Short)",
      field: "state_Short",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "Fair or Poor Health %",
      field: "fair_Poor_Health_Rate",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.fair_Poor_Health_Rate * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
      render: (rowData) =>
        (+rowData.fair_Poor_Health_Rate * 100).toFixed(2) + "%",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "Average Number of Physically Unhealthy Days",
      field: "avg_Days_Physically_Unhealthy",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "Average Number of Mentally Unhealthy Days",
      field: "avg_Days_Mentally_Unhealthy",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "Smokers %",
      field: "smokers_Rate",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.smokers_Rate * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
      render: (rowData) => (+rowData.smokers_Rate * 100).toFixed(2) + "%",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "Adults with Obesity %",
      field: "adults_Obesity_Rate",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.adults_Obesity_Rate * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
      render: (rowData) =>
        (+rowData.adults_Obesity_Rate * 100).toFixed(2) + "%",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "Food Environment Index",
      field: "food_Environment_Index",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "2px solid" },
      title: "Physically Inactive %",
      field: "physically_Inactive_Rate",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.physically_Inactive_Rate * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
      render: (rowData) =>
        (+rowData.physically_Inactive_Rate * 100).toFixed(2) + "%",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "With Access to Exercise Opportunities %",
      field: "exercise_Opportunities_Rate",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.exercise_Opportunities_Rate * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
      render: (rowData) =>
        (+rowData.exercise_Opportunities_Rate * 100).toFixed(2) + "%",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "Primary Care Physicians Rate",
      field: "primary_Care_Physicians_Rate",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "Dentist Rate",
      field: "dentist_Rate",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "Mental Health Provider Rate",
      field: "mental_Health_Provider_Rate",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "Preventable Hospitalization Rate",
      field: "preventable_Hospitalization_Rate",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "With Annual Mammogram %",
      field: "annual_Mammogram_Rate",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.annual_Mammogram_Rate * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
      render: (rowData) =>
        (+rowData.annual_Mammogram_Rate * 100).toFixed(2) + "%",
    },
    {
      headerStyle: { whiteSpace: "nowrap", borderRight: "1.5px solid" },
      title: "Vaccinated %",
      field: "vaccinated_Rate",
      customFilterAndSearch: (query, rowData) => {
        const searchText = query.toLowerCase();
        const processedData = (+rowData.vaccinated_Rate * 100).toFixed(2) + "%";
        return processedData.toLowerCase().includes(searchText);
      },
      render: (rowData) => (+rowData.vaccinated_Rate * 100).toFixed(2) + "%",
    },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      GetState().then((res) => {
        if (res.status === 200 || res.status === 204) {
          setStates(res.data.sort());
        }
      });
      getAllRankedMeasureData(stateid);
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getAllRankedMeasureData(stateid);
  }, [stateid]);

  useEffect(() => {
    GetState().then((res) => {
      if (res.status === 200 || res.status === 204) {
        setStates(res.data.sort());
      }
    });
    getAllRankedMeasureData(stateid);
  }, []);

  const getAllRankedMeasureData = (stateid) => {
    setIsLoading(true);
    GetAllRankedMeasureData(stateid)
      .then((res) => {
        if (res.status === 200 || res.status === 204) {
          setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;

    const {
      fips,
      county,
      state,
      state_Short,
      fair_Poor_Health_Rate,
      avg_Days_Physically_Unhealthy,
      avg_Days_Mentally_Unhealthy,
      smokers_Rate,
      adults_Obesity_Rate,
      food_Environment_Index,
      physically_Inactive_Rate,
      exercise_Opportunities_Rate,
      primary_Care_Physicians_Rate,
      dentist_Rate,
      mental_Health_Provider_Rate,
      preventable_Hospitalization_Rate,
      annual_Mammogram_Rate,
      vaccinated_Rate,
    } = values;

    const payload = {
      fips: +fips,
      county: county.charAt(0).toUpperCase() + county.slice(1),
      state : state.charAt(0).toUpperCase() + state.slice(1),
      state_Short: state_Short.toUpperCase(),
      fair_Poor_Health_Rate: +fair_Poor_Health_Rate,
      avg_Days_Physically_Unhealthy: +avg_Days_Physically_Unhealthy,
      avg_Days_Mentally_Unhealthy: +avg_Days_Mentally_Unhealthy,
      smokers_Rate: +smokers_Rate,
      adults_Obesity_Rate: +adults_Obesity_Rate,
      food_Environment_Index: +food_Environment_Index,
      physically_Inactive_Rate: +physically_Inactive_Rate,
      exercise_Opportunities_Rate: +exercise_Opportunities_Rate ,
      primary_Care_Physicians_Rate: +primary_Care_Physicians_Rate,
      dentist_Rate: +dentist_Rate,
      mental_Health_Provider_Rate: +mental_Health_Provider_Rate,
      preventable_Hospitalization_Rate: +preventable_Hospitalization_Rate,
      annual_Mammogram_Rate: +annual_Mammogram_Rate,
      vaccinated_Rate: +vaccinated_Rate,
    };

    if (witchAction === "add") {
      AddRankedMeasureData(payload).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("new");
          setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      AddRankedMeasureData({
        ...payload,
        id: selectedRowData.id,
      }).then((res) => {
        if (res.status === 200 || res.status === 204) {
          setIsGetData(true);
          toastFile("update");
          setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
        size={witchAction !== "delete"?'xl':null}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            Ranked Measure Data
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteRankedMeasureData(selectedRowData?.id).then((res) => {
                  if (res.status === 200 || res.status === 204) {
                    toastFile("delete");
                    setIsGetData(true);
                    setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                fips: selectedRowData?.fips ?? 0,
                county: selectedRowData?.county,
                state: selectedRowData?.state,
                state_Short: selectedRowData?.state_Short,
                fair_Poor_Health_Rate:
                  selectedRowData?.fair_Poor_Health_Rate ?? 0,
                avg_Days_Physically_Unhealthy:
                  selectedRowData?.avg_Days_Physically_Unhealthy ?? 0,
                avg_Days_Mentally_Unhealthy:
                  selectedRowData?.avg_Days_Mentally_Unhealthy ?? 0,
                smokers_Rate: selectedRowData?.smokers_Rate ?? 0,
                adults_Obesity_Rate: selectedRowData?.adults_Obesity_Rate ?? 0,
                food_Environment_Index:
                  selectedRowData?.food_Environment_Index ?? 0,
                physically_Inactive_Rate:
                  selectedRowData?.physically_Inactive_Rate ?? 0,
                exercise_Opportunities_Rate:
                  selectedRowData?.exercise_Opportunities_Rate ?? 0,
                primary_Care_Physicians_Rate:
                  selectedRowData?.primary_Care_Physicians_Rate ?? 0,
                dentist_Rate: selectedRowData?.dentist_Rate ?? 0,
                mental_Health_Provider_Rate:
                  selectedRowData?.mental_Health_Provider_Rate ?? 0,
                preventable_Hospitalization_Rate:
                  selectedRowData?.preventable_Hospitalization_Rate ?? 0,
                annual_Mammogram_Rate:
                  selectedRowData?.annual_Mammogram_Rate ?? 0,
                vaccinated_Rate: selectedRowData?.vaccinated_Rate ?? 0,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  {witchAction === "delete" ? (
                    <div className="text-wrap">
                      Are you sure that you want to delete the record?
                    </div>
                  ) : (
                    <>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="FIPS"
                            name="fips"
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                            maxLength={10}
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="County"
                            name="county"
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      
                        <Col>
                          <CustomInputField
                            label="State"
                            name="state"
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="State (Short)"
                            name="state_Short"
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="Fair or Poor Health %"
                            name="fair_Poor_Health_Rate"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="Average Number of Physically Unhealthy Days"
                            name="avg_Days_Physically_Unhealthy"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                     
                        <Col>
                          <CustomInputField
                            label="Average Number of Mentally Unhealthy Days"
                            name="avg_Days_Mentally_Unhealthy"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="Smokers %"
                            name="smokers_Rate"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="Adults with Obesity %"
                            name="adults_Obesity_Rate"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="Food Environment Index"
                            name="food_Environment_Index"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      
                        <Col>
                          <CustomInputField
                            label="Physically Inactive %"
                            name="physically_Inactive_Rate"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="With Access to Exercise Opportunities %"
                            name="exercise_Opportunities_Rate"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="Primary Care Physicians Rate"
                            name="primary_Care_Physicians_Rate"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="Dentist Rate"
                            name="dentist_Rate"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      
                        <Col>
                          <CustomInputField
                            label="Mental Health Provider Rate"
                            name="mental_Health_Provider_Rate"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="Preventable Hospitalization Rate"
                            name="preventable_Hospitalization_Rate"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                      <Row className="mb-2 gap-3">
                        <Col>
                          <CustomInputField
                            label="With Annual Mammogram %"
                            name="annual_Mammogram_Rate"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                        <Col>
                          <CustomInputField
                            label="Vaccinated %"
                            name="vaccinated_Rate"
                            maxLength={10}
                            value={values}
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            touched={touched}
                            errors={errors}
                            isRequired
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{ fontSize: "12px" }}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="d-flex justify-content-between align-items-end border-bottom py-3">
        <div className="w-50">
          <Row>
            <Col className="col-6">
              <Form.Group className="d-flex justify-content-between align-items-center">
                <Form.Label
                  className="text-start my-0"
                  style={Fontstyling.label}
                >
                  State:
                </Form.Label>
                <Form.Select
                  className="rounded-0 ms-3"
                  style={Fontstyling.label}
                  name="state"
                  ref={stateRef}
                  onChange={(e) => {
                    setStateid(e.target.value);
                    setIsGetData(true);
                  }}
                >
                  <option value="">Select State</option>
                  {states.map((item) => (
                    <option value={item}>{item}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col className="col-5 ms-2">
              <CustomButton
                onClick={() => {
                  stateRef.current.selectedIndex = 0;
                  setStateid("");
                  setIsGetData(true);
                }}
              >
                Clear
              </CustomButton>
            </Col>
          </Row>
        </div>
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add Ranked Measure Data
        </CustomButton>
      </div>
      <CustomMaterialTable
        isExport={true}
        page={"Ranked"}
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default RankedMeasureData;
